import Typography from "@mui/material/Typography";
import TableDisplay from "../../TableDisplay/TableDisplay";
import { achievedColumns, brandColumn, staticBrandWiseData, subTableComponentStyle, unitColIdentifier } from "../../data";
import BlackBorderTable from "../TableLayouts/BlackBorderTable/BlackBorderTable";
import grey from "@mui/material/colors/grey";
import { nsvTableColumns } from "./data";

const NsvTable = ({ tableRows = [], setTableRows, rowSpanColumns, customGroupBorderBottom }) => {
	const unitRow = Object.values(nsvTableColumns)?.reduce(
		(acc, row) => {
			acc[row.key] = row?.unit ?? "";
			return acc;
		},
		{ [unitColIdentifier]: "units" }
	);
	return (
		<BlackBorderTable sx={{ borderRight: "0px", display: "flex", flexWrap: "wrap", flexDirection: "column", flexGrow: 1 }}>
			<Typography textAlign="center" sx={{ background: grey[900], color: "white" }} height="24px" width="100%">
				NSV
			</Typography>
			<TableDisplay
				disableTableBorder
				columns={Object.values(nsvTableColumns)}
				rows={[unitRow, ...tableRows]}
				rowHeight="30px"
				// columnWidth="85px"
				rowSpanColumns={rowSpanColumns}
				customGroupBorderBottom={customGroupBorderBottom}
			/>
		</BlackBorderTable>
	);
};

export default NsvTable;
